import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { buildEndpointShared } from '../EndPoints';

const useCommuneService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetCommunesByRegion, setFetchingGetCommunesByRegion] = useState(false);

    const getCommunesByRegion = (region_id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: `${buildEndpointShared(
                `countries/communes/${region_id.toString()}/get-by-region`
            )}`,
            setFetching: setFetchingGetCommunesByRegion
        });
    };

    return {
        fetchingGetCommunesByRegion,
        getCommunesByRegion
    };
};

export default useCommuneService;
